module.exports = __webpack_public_path__ + "img/Bag.18128bc2.png";